import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Local} from "../../../domain/Local";
import {Observable} from "rxjs";

@Injectable()
export class LocalHttpService  extends AbstractHttpService<Local> {
    url = '/api/local';

  override bulk(items: Local[]) : Observable<Local[]>{
    console.log('antes de enviar', items)
    return this.http.post<Local[]>(this.urlBase +'/bulk', items)
  }
}
